/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { User } from './User';
export type SalesOrderDiscount = {
    /**
     * Unique discount identifier
     */
    id: number;
    /**
     * Discount type
     */
    discountType: SalesOrderDiscount.discountType;
    /**
     * Discount reason
     */
    discountReason: SalesOrderDiscount.discountReason;
    /**
     * Discount code
     */
    discountCode?: string;
    /**
     * Discount value
     */
    discountValue: number;
    /**
     * User who applied the discount
     */
    appliedBy: User;
    /**
     * Applied timestamp
     */
    appliedAt: string;
};
export namespace SalesOrderDiscount {
    /**
     * Discount type
     */
    export enum discountType {
        PERCENTAGE = 'PERCENTAGE',
        FIXED_AMOUNT = 'FIXED_AMOUNT',
        COUPON = 'COUPON',
    }
    /**
     * Discount reason
     */
    export enum discountReason {
        LOYALTY = 'LOYALTY',
        PROMOTION = 'PROMOTION',
        EMPLOYEE = 'EMPLOYEE',
        NEGOTIATION = 'NEGOTIATION',
        VOLUME = 'VOLUME',
        OTHER = 'OTHER',
    }
}

